import { createContext } from 'react'
import { MultiPaneLayoutContextType } from './multiPaneLayout.interface'

export const MultiPaneLayoutContext = createContext<MultiPaneLayoutContextType>({
    rootId: 0,
    panesConfig: {},
    paneStyles: {},
    onPaneResize: (paneId: number, dividerIndex: number, deltaX: number, deltaY: number) => {
    },
    onPaneResizeStart() {
    },
    onPaneResizeStop() {
    },
    onPaneEqualize() {
    },
    splitPane(paneId, numberOfPanes, horizontal, parentPaneId) {
    },
    deletePane(paneId, parentPaneId) {
    }
})
